export default "__VITE_ASSET__DiG5keo2__"